export const ACCESS_PERMISSION_KEYS = Object.freeze([
  "deliveries",
  "inventory",
  "orders_clients_products",
  "admin",
]);

export const FUNCTION_PERMISSION_KEYS = Object.freeze([
  "orders:create",
  "inventory:update",
]);

export const PROVIDER_ROUTE_BUCKET_MAP = Object.freeze({
  Provider_Deliveries: "deliveries",
  Provider_Delivery: "deliveries",

  Provider_Inventory: "inventory",
  Provider_Adjust: "inventory",
  Provider_Transactions: "inventory",
  Provider_Transaction: "inventory",
  Provider_New_Transaction: "inventory",
  Provider_Inbound: "inventory",
  Provider_Outbound: "inventory",

  Provider_Home: "orders_clients_products",
  Provider_Orders: "orders_clients_products",
  Provider_Order: "orders_clients_products",
  Provider_Order_Print: "orders_clients_products",
  Provider_New_Order: "orders_clients_products",
  Provider_Clients: "orders_clients_products",
  Provider_Client: "orders_clients_products",
  Provider_Client_Orders: "orders_clients_products",
  Provider_Products: "orders_clients_products",
  Provider_Product: "orders_clients_products",

  Provider_Metadata: "admin",
  Provider_Notifications: "admin",
  Provider_Notification_Events: "admin",
  Provider_Users: "admin",
  Provider_Settings: "admin",
  Provider_Locations: "admin",
  Provider_Location: "admin",
});

export const PROVIDER_BUCKET_DEFAULT_ROUTE = Object.freeze({
  deliveries: "Provider_Deliveries",
  inventory: "Provider_Inventory",
  orders_clients_products: "Provider_Home",
  admin: "Provider_Settings",
});
